// 青鸾接入文档地址：
// https://docs.popo.netease.com/lingxi/93ce13cf24744e46a11ae09adba7f5ca?appVersion=3.67.0&deviceType=4&popo_hidenativebar=1&popo_noindicator=1&disposable_login_token=1
// 埋点pid,注意埋点pid不要随意更改，数源那边的pid是有一一对应的
export var TrackerPidEnum;
(function (TrackerPidEnum) {
    TrackerPidEnum["YaotaiPortal"] = "yaotai-portal";
    TrackerPidEnum["YaotaiReception"] = "yaotai-reception";
    TrackerPidEnum["YaotaiAdmin"] = "yaotai-admin";
    TrackerPidEnum["YaotaiCorporate"] = "yaotai-corporate";
    TrackerPidEnum["CloudGame"] = "cloud-game";
})(TrackerPidEnum || (TrackerPidEnum = {}));
export var Platform;
(function (Platform) {
    Platform["H5"] = "h5";
    Platform["PC"] = "PC";
})(Platform || (Platform = {}));
// 自定义点击事件
export var BuriedEventTrigger;
(function (BuriedEventTrigger) {
    BuriedEventTrigger["CLK"] = "CLK";
    BuriedEventTrigger["EXP"] = "EXP";
    BuriedEventTrigger["OTHER"] = "OTHER";
    BuriedEventTrigger["SLD"] = "SLD";
    BuriedEventTrigger["INPUT"] = "INPUT";
})(BuriedEventTrigger || (BuriedEventTrigger = {}));
export var Env;
(function (Env) {
    Env["Dev"] = "dev";
    Env["Fat"] = "fat";
    Env["Pre"] = "pre";
    Env["Prod"] = "pro";
})(Env || (Env = {}));
export const BuriedEvent = {
    Test: { key: 'test', event: BuriedEventTrigger.CLK },
};
